module.exports = __webpack_public_path__ + "static/media/crown.8d182210.png";